import { defaulted, enums, mask, nullable, object, string, trimmed } from 'superstruct';
import { emptyStringIsNull, parsableBoolean, requireFields, userString } from '@arc/shared/util-superstruct';
export const VIEW_FILTER_MODES = ['active-only', 'archived-only', 'active-and-archived'];
export const CREATED_FILTER_DAY_RANGE_VALUES = [
// NOTE not meant to be const
'last-P7D', 'last-P14D', 'last-P1M', 'last-P2M', 'last-P3M'];
export const CREATED_FILTER_TYPES = [
// NOTE values are meant to be const
'all-time', 'last-P7D', 'last-P14D', 'last-P1M', 'last-P2M', 'last-P3M', 'custom'];
export const DELETE_FILTER_TYPES = [
// NOTE values are meant to be const - focused on future dates
'all-time', 'today', 'next-P2D', 'next-P3D', 'next-P7D', 'next-P14D', 'next-P1M', 'next-P2M', 'next-P3M', 'custom'];
export const BaseFilterDto = object({
  name: userString('validations:Required Filter Name'),
  viewMode: enums(VIEW_FILTER_MODES),
  createdType: requireFields(enums(CREATED_FILTER_TYPES), ['createdRangeStart', 'createdRangeEnd'], {
    amountRequired: 1,
    validator: value => value === 'custom',
    message: 'validations:Required Custom Date'
  }),
  createdRangeStart: string(),
  createdRangeEnd: string(),
  saved: defaulted(parsableBoolean(), () => false),
  savedAll: defaulted(parsableBoolean(), () => false),
  savedDefault: defaulted(parsableBoolean(), () => false)
});
export const DefaultBaseFilterFormValues = () => mask({
  name: 'Default',
  saved: false,
  savedAll: false,
  savedDefault: false,
  viewMode: 'active-only',
  createdType: 'all-time',
  createdRangeStart: '',
  createdRangeEnd: ''
}, BaseFilterDto);
export const BaseFilterFormExtraFieldsDto = object({
  generatedName: trimmed(emptyStringIsNull(string())),
  originalName: defaulted(nullable(string()), () => null),
  nameEdited: defaulted(parsableBoolean(), () => false)
});